(function () {

    'use strict';

    angular.module('asys')
        .component('asysErgebnisZeileKonditionen', {
            bindings: {
                showProzentBetrag: '@aezpgShowProzentBetrag',
                konditionen: '<aezpgKonditionen'
            },
            templateUrl: 'ergebnis/partials/ergebnisZeileKonditionen.html',
            controller: ErgebnisZeileKonditionenController,
            controllerAs: 'ergZeileKondVm'
        });

    ErgebnisZeileKonditionenController.$inject = [
        'MiscUtilsService',
        'MoneyUtilsService'
    ];
    function ErgebnisZeileKonditionenController(MiscUtilsService, MoneyUtilsService) {
        var vm = this;

        vm.getKonditionBetragOrProzent = getKonditionBetragOrProzent;

        function getKonditionBetragOrProzent(kondition) {
            var returnVal = ': ';

            if (MiscUtilsService.isEmpty(kondition) || vm.showProzentBetrag !== 'true') {
                return '';
            }

            if (MiscUtilsService.isNotEmpty(kondition.prozent)) {
                returnVal += kondition.prozent + '&nbsp;%';
            } else if (MiscUtilsService.isNotEmpty(kondition.betrag)) {
                returnVal += MoneyUtilsService.toMoneyString(kondition.betrag, {
                    decimal: 2,
                    currency: 'code'
                });
            } else {
                return '';
            }

            return returnVal;
        }
    }

})();
